import type { ReportEvidenceModel } from "@cle/models/reportEvidence";
import type {
  PendingEvidenceResponse,
  PrepareEfteruddannelseIndberetningRequest,
  PrepareEfteruddannelseIndberetningResponse,
} from "@/interfaces/efteruddannelseIndberetning";
import { ApiRequestError, getWithErrorObject, post } from "./util";

const INDBERETNING_QUERY = "Efteruddannelse/indberetning";

export const EFT_INDBERETNING_QUERY_KEY = [
  "efteruddannelse",
  "indberetning",
] as const;

export const createPendingEvidenceQueryKey = (indberetningId: string) =>
  [...EFT_INDBERETNING_QUERY_KEY, "pending-evidence", indberetningId] as const;

export const createPeriodEvidenceQueryKey = (periodId: string) =>
  [...EFT_INDBERETNING_QUERY_KEY, "period", periodId, "evidence"] as const;

export const prepareEfteruddannelseIndberetningForSigning = (
  request: PrepareEfteruddannelseIndberetningRequest,
): Promise<PrepareEfteruddannelseIndberetningResponse> =>
  post<PrepareEfteruddannelseIndberetningResponse>({
    query: `${INDBERETNING_QUERY}/prepare-for-signing`,
    body: request,
  });

export const getReportEvidenceByPeriod = async (
  periodId: string,
): Promise<ReportEvidenceModel[]> => {
  try {
    return await getWithErrorObject<ReportEvidenceModel[]>({
      query: `${INDBERETNING_QUERY}/periods/${periodId}/evidence`,
    });
  } catch (error) {
    if (error instanceof ApiRequestError && error.status === 404) {
      return [];
    }

    throw error;
  }
};

export const getPendingIndberetningEvidence = async (
  indberetningId: string,
): Promise<PendingEvidenceResponse> => {
  try {
    return await getWithErrorObject<PendingEvidenceResponse>({
      query: `${INDBERETNING_QUERY}/${indberetningId}/pending-evidence`,
    });
  } catch (error) {
    if (error instanceof ApiRequestError && error.status === 404) {
      return { evidenceItemIds: [] };
    }

    throw error;
  }
};
